module.exports = __webpack_public_path__ + "media/images/welcome-customerbase-7953db7c9b44698e0a1ef03d8afd1b65.png";